(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page--products-fv"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-testid^="products-fv-"]');
    sections.forEach(function (section) {
      var duration = (parseInt(section.getAttribute('data-fv-duration'), 10) || 5) * 1000;
      var desktopSlides = section.querySelectorAll('[data-fv-slide]');
      var mobileSlides = section.querySelectorAll('[data-fv-slide-mobile]');
      var totalDesktop = desktopSlides.length;
      var totalMobile = mobileSlides.length;

      if (totalDesktop <= 1 && totalMobile <= 1) return;

      var currentIndex = 0;

      setInterval(function () {
        var nextIndex = (currentIndex + 1) % Math.max(totalDesktop, totalMobile);

        desktopSlides.forEach(function (s) {
          s.classList.remove('products-fv__slide--active');
        });
        mobileSlides.forEach(function (s) {
          s.classList.remove('products-fv__slide--active');
        });

        if (desktopSlides[nextIndex]) {
          desktopSlides[nextIndex].classList.add('products-fv__slide--active');
        }
        if (mobileSlides[nextIndex]) {
          mobileSlides[nextIndex].classList.add('products-fv__slide--active');
        }

        currentIndex = nextIndex;
      }, duration);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page--products-specs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-testid^="products-specs-"]');
    sections.forEach(function (section) {
      var thumbs = section.querySelectorAll('[data-specs-thumb]');
      var mains = section.querySelectorAll('[data-specs-main]');
      if (thumbs.length === 0) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = this.getAttribute('data-specs-thumb');

          thumbs.forEach(function (t) {
            t.classList.remove('products-specs__thumbnail--active');
          });
          this.classList.add('products-specs__thumbnail--active');

          mains.forEach(function (m) {
            m.classList.remove('products-specs__main-image-item--active');
          });
          var target = section.querySelector('[data-specs-main="' + index + '"]');
          if (target) {
            target.classList.add('products-specs__main-image-item--active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
